import React, { useMemo } from 'react';
import { Rule } from 'antd/lib/form';
import { useTranslation } from 'react-i18next';
import { FormInputNew } from 'components/Input/FormInputNew';

interface IProps {
	changeBaseMcc: (value: Nullable<number>) => void;
}

export const BaseMccField: React.FC<IProps> = React.memo(({ changeBaseMcc }) => {
	const { t } = useTranslation('error');

	const validationRules = useMemo<Rule[]>(() => [{ required: true, message: t('enterBaseMcc') }], [t]);

	return (
		<FormInputNew
			testId="BaseMccField"
			type="number"
			min={1000}
			max={9999}
			name="baseMcc"
			label="baseMccLabel"
			validationRules={validationRules}
			onChangeNumber={changeBaseMcc}
		/>
	);
});
